import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeItemListName, getAmplitudeViewItemEventProperties, IAmplitudeViewItemOffer} from "./get_amplitude_view_item_event_properties";

export interface ITrackAmplitudeInvestmentViewItemParams {
    offer: IAmplitudeViewItemOffer;
    itemListId?: string;
    itemListName?: AmplitudeItemListName;
}

export const trackAmplitudeInvestmentViewItem = (params: ITrackAmplitudeInvestmentViewItemParams) => {
    const {offer, itemListId, itemListName} = params;

    trackAmplitudeEvent("view_item", {
        location: "investment_page",
        property_id: null,
        price: null,
        item_list_id: null,
        item_list_name: null,
        event_category: null,
        variant_name: null,
        variant_area: null,
        variant_rooms: null,
        variant_floor: null,
        item_category2: null,
        item_category3: null,
        item_category4: null,
        item_category5: null,
        ...getAmplitudeViewItemEventProperties({
            offer,
            itemListId,
            itemListName
        })
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeItemListName, getAmplitudeViewItemEventProperties, IAmplitudeViewItemOffer} from "./get_amplitude_view_item_event_properties";

export interface ITrackAmplitudeInvestmentViewItemParams {
    offer: IAmplitudeViewItemOffer;
    itemListId?: string;
    itemListName?: AmplitudeItemListName;
}

export const trackAmplitudeInvestmentViewItem = (params: ITrackAmplitudeInvestmentViewItemParams) => {
    const {offer, itemListId, itemListName} = params;

    trackAmplitudeEvent("view_item", {
        location: "investment_page",
        property_id: null,
        price: null,
        item_list_id: null,
        item_list_name: null,
        event_category: null,
        variant_name: null,
        variant_area: null,
        variant_rooms: null,
        variant_floor: null,
        item_category2: null,
        item_category3: null,
        item_category4: null,
        item_category5: null,
        ...getAmplitudeViewItemEventProperties({
            offer,
            itemListId,
            itemListName
        })
    });
};
